











import { Component, Vue, Prop } from "vue-property-decorator";

export interface ListItem {
  label: string;
  value: string;
}

@Component
export default class SimpleListCard extends Vue {
  @Prop({ required: true })
  title!: string;

  @Prop({ default: undefined })
  icon?: string;

  @Prop({ required: true })
  items!: ListItem[];
}
